var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"src":_vm.mediaEntry[0],"alt":"Ad item","max-width":"250"}})}
var staticRenderFns = []

export { render, staticRenderFns }